export default api => ({
  getPreLoginToken: async () =>
    await api.get('/api/viaje-naranja/itau/pre-login-token'),
  clientClientPoints: async (token: string) =>
    await api.post('/api/viaje-naranja/itau/client-points', {
      token
    })
});
